import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import en from './locales/en.json';
import tr from './locales/tr.json';

// Function to detect language based on geolocation
const detectLanguageByLocation = async () => {
  try {
    // First check localStorage for saved preference
    const savedLang = localStorage.getItem('i18nextLng');
    if (savedLang && (savedLang === 'en' || savedLang === 'tr')) {
      return savedLang;
    }

    // Try to detect location via IP geolocation
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    
    // If user is from Turkey, default to Turkish
    if (data.country_code === 'TR') {
      return 'tr';
    }
    
    // Otherwise default to English
    return 'en';
  } catch (error) {
    console.log('Geolocation detection failed, using browser language');
    
    // Fallback to browser language detection
    const browserLang = navigator.language || navigator.languages[0];
    if (browserLang.startsWith('tr')) {
      return 'tr';
    }
    return 'en';
  }
};

// Initialize i18n
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tr: { translation: tr }
    },
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

// Detect and set initial language
detectLanguageByLocation().then(detectedLang => {
  i18n.changeLanguage(detectedLang);
});

export default i18n;